module.exports = __webpack_public_path__ + "img/header-mobile.90c92fb3.png";